export default __webpack_public_path__ + "static/media/weather-icon.921ceed1.jpg";